import ApiBase from 'Services/Api/ApiBase';

class MeSettings extends ApiBase {
    route = '/human-resources/me-settings';
};

export default new MeSettings();